// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"dad6d806","257":"d5fd7d0b","278":"3ecf7c00","347":"31c8ea85","355":"3cce5df1","821":"4ab28bf7"}[chunkId] + ".chunk.js";
};